import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthLayout } from '../AuthLayout';
import { RegisterCard } from './RegisterCard';
import { RegisterHeader } from './components/RegisterHeader';
import { RegisterForm } from './components/RegisterForm';
import { generateSecurePassword } from '../../../../../helpers/password-helper';
import { startRegister } from '../../../../../actions/auth';
import { setError, unsetError } from '../../../../../actions/ui';

export const RegisterScreen = () => {
    const dispatch = useDispatch();
    const { error, loading } = useSelector(state => state.ui); 

    const [formValues, setFormValues] = useState({
        company: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: ''
    });

    const [acceptedTerms, setAcceptedTerms] = useState(false);

    const handleInputChange = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.name]: target.value
        });
    };

    const handleTermsChange = ({ target }) => {
        setAcceptedTerms(target.checked);
    };

    const handlePasswordGenerate = () => {
        const newPassword = generateSecurePassword(16);
        setFormValues({
            ...formValues,
            password: newPassword,
            confirmPassword: newPassword
        });
    };

    const handleRegister = (e) => {
        e.preventDefault();
        dispatch(unsetError());

        const { company, firstName, lastName, email, password, confirmPassword } = formValues;

        // Validación de contraseñas
        if (password !== confirmPassword) {
            dispatch(setError('Las contraseñas no coinciden'));
            return;
        }

        // Validación de términos
        if (!acceptedTerms) {
            dispatch(setError('Debes aceptar los términos y condiciones'));
            return;
        }

        // Dispatch de la acción de registro
        dispatch(startRegister(company, firstName, lastName, email, password));
    };

    return (
        <AuthLayout>
            <RegisterCard>
                <RegisterHeader />
                <RegisterForm
                    formValues={formValues}
                    onChange={handleInputChange}
                    onSubmit={handleRegister}
                    onPasswordGenerate={handlePasswordGenerate}
                    acceptedTerms={acceptedTerms}
                    onTermsChange={handleTermsChange}
                    error={error}
                    loading={loading}
                />
                <div className="mt-5 text-muted">
                    <span>¿Ya tienes una cuenta? </span>
                    <a className="fw-bold" href='/auth/login' style={{ cursor: 'pointer' }} >
                        Iniciar sesión
                    </a>
                </div>
            </RegisterCard>
        </AuthLayout>
    )
}
